import { Form, Input, Select } from 'antd';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { useCancellationReasons } from 'app/hooks/data/useCancellationReasons';
import { HOTEL_INCOMPATIBLE_REASON_IDS } from 'app/typings/cancellationReason';
import { BOOKING_REFUND_SOURCE } from 'app/typings/core/common/enum/bookingRefundSource';

import styles from './Modals.module.scss';

const { Option } = Select;

export const CancellationFormFields = () => {
  const form = Form.useFormInstance();
  const { data: cancellationReasons } = useCancellationReasons();

  const source = Form.useWatch('source', form);
  const isHotelSource = source === BOOKING_REFUND_SOURCE.HOTEL;

  return (
    <>
      <FormLineLayout label="Reason type" isRequired>
        <Form.Item
          label="Reason type"
          name="reasonId"
          rules={[{ required: true }]}
          noStyle
        >
          <Select>
            {cancellationReasons?.map((reason) => (
              <Option
                key={reason.id}
                value={reason.id}
                disabled={
                  isHotelSource &&
                  HOTEL_INCOMPATIBLE_REASON_IDS.includes(reason.id)
                }
              >
                {reason.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {() =>
            form.getFieldError('reasonId').length > 0 && (
              <div className={styles.errorMessage}>
                {form.getFieldError('reasonId')[0]}
              </div>
            )
          }
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Comment" labelOnTop>
        <Form.Item label="Comment" name="comment" noStyle>
          <Input.TextArea rows={2} placeholder="Optional" />
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {() =>
            form.getFieldError('comment').length > 0 && (
              <div className={styles.errorMessage}>
                {form.getFieldError('comment')[0]}
              </div>
            )
          }
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
